import { useEffect } from 'react';

const DEFAULT_THEME_COLOR = '#6B21A8';

export function useThemeColor(color: string): void {
  useEffect(() => {
    const meta = document.querySelector('meta[name="theme-color"]');
    if (!meta) return undefined;

    const previous = meta.getAttribute('content');
    meta.setAttribute('content', color);

    return () => {
      meta.setAttribute('content', previous ?? DEFAULT_THEME_COLOR);
    };
  }, [color]);
}
